import { render, staticRenderFns } from "./TalentBio.vue?vue&type=template&id=0b987b31&scoped=true"
import script from "./TalentBio.vue?vue&type=script&lang=js"
export * from "./TalentBio.vue?vue&type=script&lang=js"
import style0 from "./TalentBio.vue?vue&type=style&index=0&id=0b987b31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b987b31",
  null
  
)

export default component.exports